export const ONE_MINUTE = 1000 * 60
export const FIVE_MINUTES = ONE_MINUTE * 5
export const HALF_HOUR = ONE_MINUTE * 30
export const ONE_HOUR = ONE_MINUTE * 60
export const ONE_DAY = ONE_HOUR * 24
export const ONE_WEEK = ONE_DAY * 7
export const THIRTY_SECONDS = 1000 * 30
